/** Arabic Terms of Use copy (VizHacks public site). */
const termsAr = {
  intro: {
    h2: "الموافقة على الشروط",
    p1: [
      'تُنظّم شروط الاستخدام هذه («الشروط») وصولكم إلى موقعنا الإلكتروني والخدمات عبر الإنترنت التي تديرها شركة VIZHACKS LTD («VizHacks» أو «نحن» أو «لنا» أو «خاصتنا»). باستخدامكم للخدمات فإنكم توافقون على هذه الشروط. إن لم توافقوا، يجب ألا تستخدموا الخدمات.',
    ],
    p2: {
      before: "",
      privacyLink: "سياسة الخصوصية",
      after:
        "تشرح كيف نتعامل مع المعلومات الشخصية، وهي جزء من فهمكم لكيفية عمل الخدمات.",
    },
  },
  services: {
    h2: "الخدمات",
    p1: "تشمل الخدمات موقعنا العام ونماذج الاستفسار وطلب الخدمة والمحتوى ذي الصلة. ما لم نتفق خلاف ذلك في عقد مكتوب منفصل، فإن استخدام الموقع لا يُنشئ من تلقاء نفسه علاقة استشارية أو عميلاً. أي عرض أو بيان أو تقدير يُقدَّم عبر الموقع يكون إرشادياً فقط ما لم يُؤكَّد كتابياً بموجب اتفاق بينكم وبين VizHacks.",
  },
  acceptable: {
    h2: "الاستخدام المقبول",
    p1: "توافقون على عدم:",
    items: [
      "استخدام الخدمات بما يخالف القوانين أو اللوائح المعمول بها",
      "إرسال معلومات زائفة أو مضلِّلة أو احتيالية، أو انتحال شخص أو جهة",
      "استخراج أو جمع أو تعدين بيانات أو نسخ المحتوى من الخدمات بشكل منهجي دون موافقتنا الكتابية المسبقة",
      "استخدام برامج آلية أو سكربتات أو وسائل آلية لإرسال النماذج أو إرهاق الأنظمة أو توليد زحف زائد",
      "محاولة الحصول على وصول غير مصرّح به إلى أنظمتنا أو حساباتنا أو بياناتنا أو شبكاتنا، أو مسح الثغرات أو اختبارها دون إذن",
      "إدخال برمجيات خبيثة أو التدخل في تشغيل الخدمات أو الإضرار بالمستخدمين الآخرين أو أطراف ثالثة",
      "تحميل أو نقل محتوى غير قانوني أو تشهيري أو مضايقة أو كراهية أو غير مقبول بطريقة أخرى",
    ],
    p2: "قد نحقّق في الاشتباه بانتهاكات ونتعاون مع جهات إنفاذ القانون. قد نعلق أو ننهي الوصول أو نزيل محتوى أو نمنع إرسالات حيث نعتقد بشكل معقول أن هذه الشروط قد اُنتُهكت أو عند الضرورة لحماية الخدمات.",
  },
  monitoring: {
    h2: "المراقبة الأمنية",
    p1: "لحماية الخدمات، قد نستخدم تدابير تقنية تشمل التسجيل وتحديد المعدل والتصفية وتحليل الزحف والإرسالات. باستخدامكم للخدمات، تقرون بأن مثل هذه التدابير قد تُطبَّق وفق سياسة الخصوصية لدينا.",
  },
  ip: {
    h2: "الملكية الفكرية",
    p1: "الخدمات، بما في ذلك النصوص والرسوم والشعارات والتخطيطات والبرمجيات، مملوكة لـ VizHacks أو لمرخّصينا ومحمية بقوانين الملكية الفكرية. باستثناء النسخ المؤقتة اللازمة للتصفح، لا يجوز نسخها أو تعديلها أو توزيعها أو إنشاء أعمال مشتقة دون إذننا الكتابي المسبق.",
  },
  disclaimer: {
    h2: "إخلاء المسؤولية",
    p1: "تُقدَّم الخدمات «كما هي» و«حسب التوفر» في أوسع حد يسمح به القانون. نخلي مسؤوليتنا عن جميع الضمانات، صريحة كانت أو ضمنية أو نظامية، بما في ذلك ضمانات القابلية للتسويق والملاءمة لغرض معين وعدم الانتهاك. لا نضمن أن تكون الخدمات دون انقطاع أو خالية من الأخطاء أو من مكوّنات ضارة.",
  },
  liability: {
    h2: "تحديد المسؤولية",
    p1: "في أوسع حد يسمح به القانون المعمول به، لا تتحمل VizHacks ومديروها وموظفوها والشركات التابعة لها المسؤولية عن أي أضرار غير مباشرة أو عرضية أو خاصة أو تبعية أو عقابية، أو عن فقدان أرباح أو بيانات أو سمعة أو فرص أعمال، ناشئة عن استخدامكم للخدمات أو مرتبطة به، حتى إن أُبلغنا بإمكانية حدوث مثل هذه الأضرار.",
    p2: "لا يستثني شيء في هذه الشروط ولا يحدّ من المسؤولية التي لا يجوز استثناؤها أو تقييدها بموجب القانون المعمول به (بما في ذلك المسؤولية عن الوفاة أو الإصابة الشخصية الناجمة عن الإهمال، أو الاحتيال).",
  },
  indemnity: {
    h2: "التعويض",
    p1: "في الحد الذي يسمح به القانون، توافقون على تعويض VizHacks وحمايتها من المطالبات والأضرار والخسائر والنفقات (بما في ذلك أتعاب قانونية معقولة) الناشئة عن استخدامكم للخدمات أو محتواكم أو إرسالاتكم أو إخلالكم بهذه الشروط.",
  },
  law: {
    h2: "القانون المختص والاختصاص القضائي",
    p1: "تخضع هذه الشروط لقوانين إنجلترا وويلز دون اعتبار لتعارض القوانين. تكون محاكم إنجلترا وويلز لها الاختصاص الحصري للنزاعات الناشئة عن هذه الشروط أو الخدمات أو المرتبطة بها، مع مراعاة أي حقوق إلزامية قد تتمتعون بها كمستهلكين في بلد إقامتكم.",
  },
  changes: {
    h2: "التغييرات",
    p1: "قد نعدّل هذه الشروط في أي وقت. سنُحدّث تاريخ «آخر تحديث» في هذه الصفحة عند إجراء تغييرات جوهرية. استمراركم في استخدام الخدمات بعد سريان التغييرات يُعدّ قبولاً للشروط المعدّلة. إن لم توافقوا، يجب التوقف عن استخدام الخدمات.",
  },
  contact: {
    h2: "التواصل",
    p1: {
      before: "يمكن إرسال أسئلة حول هذه الشروط عبر",
      linkLabel: "نموذج الاتصال",
      after: "أو باستخدام بيانات الشركة الظاهرة في تذييل الموقع.",
    },
    address: ["VIZHACKS LTD", "167–169 Great Portland Street, 5th Floor", "London, W1W 5PF, England"],
  },
};

export default termsAr;
